// extracted by mini-css-extract-plugin
module.exports = {"vBlue":"#107ef1","wrapper":"LoadMore__wrapper___o3pi9","button":"LoadMore__button___wnHQk"};